"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.Footer = exports.Header = exports.LayoutContext = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var config_provider_1 = require("../config-provider");
exports.LayoutContext = React.createContext({
    siderHook: {
        addSider: function () { return null; },
        removeSider: function () { return null; },
    },
});
function generator(_a) {
    var suffixCls = _a.suffixCls, tagName = _a.tagName, displayName = _a.displayName;
    return function (BasicComponent) {
        var Adapter = function (props) {
            var getPrefixCls = React.useContext(config_provider_1.ConfigContext).getPrefixCls;
            var customizePrefixCls = props.prefixCls;
            var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
            return React.createElement(BasicComponent, tslib_1.__assign({ prefixCls: prefixCls, tagName: tagName }, props));
        };
        Adapter.displayName = displayName;
        return Adapter;
    };
}
var Basic = function (props) {
    var prefixCls = props.prefixCls, className = props.className, children = props.children, tagName = props.tagName, others = tslib_1.__rest(props, ["prefixCls", "className", "children", "tagName"]);
    var classString = (0, classnames_1.default)(prefixCls, className);
    return React.createElement(tagName, tslib_1.__assign({ className: classString }, others), children);
};
var BasicLayout = function (props) {
    var _a;
    var direction = React.useContext(config_provider_1.ConfigContext).direction;
    var _b = tslib_1.__read(React.useState([]), 2), siders = _b[0], setSiders = _b[1];
    var prefixCls = props.prefixCls, className = props.className, children = props.children, hasSider = props.hasSider, Tag = props.tagName, others = tslib_1.__rest(props, ["prefixCls", "className", "children", "hasSider", "tagName"]);
    var classString = (0, classnames_1.default)(prefixCls, (_a = {},
        _a["".concat(prefixCls, "-has-sider")] = typeof hasSider === 'boolean' ? hasSider : siders.length > 0,
        _a["".concat(prefixCls, "-rtl")] = direction === 'rtl',
        _a), className);
    return (React.createElement(exports.LayoutContext.Provider, { value: {
            siderHook: {
                addSider: function (id) {
                    // @ts-ignore
                    setSiders(function (prev) { return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(prev), false), [id], false); });
                },
                removeSider: function (id) {
                    setSiders(function (prev) { return prev.filter(function (currentId) { return currentId !== id; }); });
                },
            },
        } },
        React.createElement(Tag, tslib_1.__assign({ className: classString }, others), children)));
};
var Layout = generator({
    suffixCls: 'layout',
    tagName: 'section',
    displayName: 'Layout',
})(BasicLayout);
var Header = generator({
    suffixCls: 'layout-header',
    tagName: 'header',
    displayName: 'Header',
})(Basic);
exports.Header = Header;
var Footer = generator({
    suffixCls: 'layout-footer',
    tagName: 'footer',
    displayName: 'Footer',
})(Basic);
exports.Footer = Footer;
var Content = generator({
    suffixCls: 'layout-content',
    tagName: 'main',
    displayName: 'Content',
})(Basic);
exports.Content = Content;
exports.default = Layout;
//# sourceMappingURL=layout.js.map